import router from '../router'

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  // time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}
export function formatDate(timestamp, type) {
    let date = new Date();
    if (timestamp) {
        date = new Date(timestamp);
    }
    let time = ''
    let Y = date.getFullYear();
    let M = date.getMonth() + 1;
    let D = date.getDate();
    let h = date.getHours();
    let m = date.getMinutes();
    let s = date.getSeconds();
    if (M < 10) M = '0' + M
    if (D < 10) D = '0' + D
    if (h < 10) h = '0' + h
    if (m < 10) m = '0' + m
    if (s < 10) s = '0' + s;
    if (type == 1) {
        time = Y + '年' + M + '月' + D + '日'
    }else if (type == 2) {
        time = Y + '/' + M + '/' + D 
    }else if(type == 3){
        time = Y + "-" + M + "-" + D 
    } else {
        time = Y + "-" + M + "-" + D + " " + h + ':' + m + ':' + s;
    }
    if (!timestamp) {
        time = Y + "/" + M + "/" + D 
    }
    return time;
}
export function routelus(num) {
  // console.log(num, 'num');
  if (num == 0) {
    router.push({path: '/'})
  }
  if (num == 1) {
    router.push({path: '/about'})
  }
  if (num == 2) {
    router.push({path: '/songList'})
  }
}

export function sizeMB(e) {
  return e/1024/1024 +'MB';
};



// WEBPACK FOOTER //
// ./src/utils/index.js